import request from '@/utils/request'

// 查询合伙人申请分页
export function pagePartner(data) {
  return request({
    url: '/partner/partner/page',
    method: 'post',
    data: data
  })
}

// 查询合伙人申请详情
export function getPartnerDetail(data) {
  return request({
    url: '/partner/partner/detail',
    method: 'post',
    data: data
  })
}

// 审核合伙人申请
export function auditPartner(data) {
  return request({
    url: '/partner/partner/audit',
    method: 'post',
    data: data
  })
}

// 删除合伙人申请
export function delPartner(data) {
  return request({
    url: '/partner/partner/delete',
    method: 'post',
    data: data
  })
}

// 导出合伙人申请
export function exportPartner(data) {
  return request({
    url: '/partner/partner/export',
    method: 'post',
    data: data
  })
}
